module.exports = __webpack_public_path__ + "static/media/elsalvadorflag.6a9fdde3.png";